export default "__VITE_ASSET__B5bxHl5v__"